// 关注的空间

import React, { useState } from "react";
// import TeamSpaceDetail from '../TeamSpace/TeamSpaceDetail/index';

class SpaceList extends React.Component {
  render() {
    return null;
    // return <TeamSpaceDetail type="follow" />;
  }
}

export default SpaceList;
